import { memo, useState, useRef } from 'react'

import ConfirmationServiceContext from './ConfirmationServiceContext'
import ConfirmComponent from './'

const ConfirmationProvider = memo(
  ({ value, children }) => (
    <ConfirmationServiceContext.Provider value={value}>
      {children}
    </ConfirmationServiceContext.Provider>
  ),
  () => true,
)

const ConfirmationServiceProvider = ({ children, t }) => {
  const [confirmationState, setConfirmationState] = useState(null)

  const awaitingPromiseRef = useRef()

  const openConfirmation = options => {
    setConfirmationState({
      catchOnCancel: false,
      ...options,
    })
    return new Promise((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject }
    })
  }

  const handleClose = () => {
    if (confirmationState.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject()
    }
    setConfirmationState(null)
  }

  const handleSubmit = result => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve(result)
    }
    setConfirmationState(null)
  }

  return (
    <>
      <ConfirmationProvider value={openConfirmation}>
        {children}
      </ConfirmationProvider>

      {!!confirmationState && (
        <ConfirmComponent
          onSubmit={handleSubmit}
          onClose={handleClose}
          t={t}
          {...confirmationState}
        />
      )}
    </>
  )
}

export default memo(ConfirmationServiceProvider, () => true)
